// Function to reapply event listeners
const reapplyEventListeners = () => {
  // Your code to reattach event listeners goes here
  const checkoutButton = document.getElementById('checkout');
  if (checkoutButton) {
    checkoutButton.addEventListener('click', checkoutButtonClickHandler);
  }
}

// Define the click event handler for the checkout button
const checkoutButtonClickHandler = (event) => {
  const specificText = document.querySelector('.mw-text.mw-text--style-strong');
  let checkboxChecked = false;
  const checkboxes = document.querySelectorAll('.rale-checkbox input[type="checkbox"]');
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      checkboxChecked = true;
    }
  });

  // Check if at least one checkbox is checked and if the specific text "Payment Method" is present and visible
  if (checkboxChecked && specificText && isElementVisible(specificText) && specificText.innerText.trim() === "Payment Method") {
    // If all conditions are true, prevent default action
    event.preventDefault();
    alert('Please select a Payment Method');
  }
}

// Function to check if an element is visible
const isElementVisible = (element) => {
  return element.offsetHeight > 0 && element.offsetWidth > 0;
}

// Create a MutationObserver to watch for changes in the DOM
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if nodes were added or removed
    if (mutation.type === 'childList') {
      // Reapply event listeners when the DOM changes
      reapplyEventListeners();
    }
  });
});

// Start observing the document body for mutations
observer.observe(document.body, { childList: true, subtree: true });

// Initially apply event listeners when the page loads
reapplyEventListeners();
